import ICThunderDisable from 'assets/icons/thunder-disable.svg'
import ICThunder from 'assets/icons/thunder-icon.svg'
import CustomButton from 'components/Buttons/CustomButton'
import LoadingV2 from 'components/LoadingV2'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Form,
  Input,
  Modal,
  ModalBody,
  Spinner,
} from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import IconChoosePayment from '../../../../assets/icons/icon-choose-payment.svg'
import {
  getDetailProfile,
  getPricing,
  postConfirmTransaction,
} from '../dashboardAction'
import { ArrowRight, X } from 'react-feather'
import usePartialUpload from 'hooks/usePartialUpload'
import ModalTakePhotoRelease from './ModalTakePhotoRelease'

const ModalChoosePayment = ({
  isOpen,
  toggle,
  transaction,
  refetchTransactionById,
  isChangeInstantPayment,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { pricing, balance, loading } = useSelector((s) => s.dashboard)
  const { serviceProvision } = useSelector((s) => s.auth)
  const [fileNames, setFileNames] = useState([])
  const [files, setFiles] = useState([])
  const [images, setImages] = useState([])
  const [imageUrls, setImageUrls] = useState([])
  const [proofFileNames, setProofFileNames] = useState([])
  const [proofFiles, setProofFiles] = useState([])
  const [proofImages, setProofImages] = useState([])
  const [proofImageUrls, setProofImageUrls] = useState([])
  const [selectedPricing, setSelectedPricing] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [isProofUploading, setIsProofUploading] = useState(false)
  const [isOpenModalTakePhoto, setIsOpenModalTakePhoto] = useState(false)
  const [isOpenModalTakePhotoProof, setIsOpenModalTakePhotoProof] =
    useState(false)
  const [note, setNote] = useState('')
  const toggleModal = () => {
    setIsOpenModalTakePhoto(!isOpenModalTakePhoto)
  }
  const toggleModalProof = () => {
    setIsOpenModalTakePhotoProof(!isOpenModalTakePhotoProof)
  }

  const { uploadFile } = usePartialUpload()

  useEffect(() => {
    if (
      isOpen &&
      transaction &&
      (transaction?.status === 'Diproses' ||
        (transaction?.status === 'Selesai' && isChangeInstantPayment)) &&
      !transaction?.orderDetail?.autoRelease
      // && !transaction?.orderDetail?.useProofOfPayment
    ) {
      dispatch(getPricing({ escrowpaymentId: transaction?.escrowpaymentId }))
    }

    if (isOpen && transaction) {
      dispatch(
        getDetailProfile({
          id: transaction?.id,
          type: transaction?.orderDetail?.type,
        }),
      )
    }
    if (!isOpen) {
      setFileNames([])
      setFiles([])
      setProofFileNames([])
      setProofFiles([])
      setProofImages([])
      setProofImageUrls([])
      setNote('')
    }
  }, [isOpen, transaction, dispatch])

  if (loading) <LoadingV2 />

  const handleConfirm = async () => {
    try {
      setIsLoading(true)
      const payload = {
        escrowPaymentId:
          transaction?.escrowPaymentId ?? transaction?.escrowpaymentId,
        useDisbursementpricingId: transaction?.orderDetail?.useProofOfPayment
          ? 0
          : (selectedPricing ?? pricing?.items?.find((e) => e?.fee === 0)?.id),
        ...((serviceProvision?.transactionProof ||
          imageUrls?.length > 0 ||
          files?.length > 0) && {
          photos: [
            ...(imageUrls ?? []),
            ...(files?.map((e) => e?.fileUrl) ?? []),
          ],
        }),
        ...((transaction?.orderDetail?.useProofOfPayment ||
          transaction?.orderDetail?.useProofOfpayment) &&
          transaction?.orderDetail?.paymentTime && {
            proofOfPayment: [
              ...(proofImageUrls ?? []),
              ...(proofFiles?.map((e) => e?.fileUrl) ?? []),
            ],
          }),
        note: note,
      }

      const res = await dispatch(
        postConfirmTransaction({ payload, isChangeInstantPayment }),
      )

      if (res?.payload?.status === 200 || res?.payload?.id) {
        toggle()
        refetchTransactionById()

        enqueueSnackbar(
          `${isChangeInstantPayment ? 'Opsi pembayaran berhasil diubah.' : 'Konfirmasi barang sampai berhasil. Transaksi selesai.'}`,
          {
            variant: 'success',
          },
        )
        setFileNames([])
        setFiles([])
        setImages([])
        setImageUrls([])
        setProofFileNames([])
        setProofFiles([])
        setProofImages([])
        setProofImageUrls([])
        setNote('')
      } else {
        throw res
      }
    } catch (error) {
      console.warn(error)
      setIsLoading(false)
      enqueueSnackbar(
        error?.payload ?? error?.message ?? error?.error?.message,
        {
          variant: 'error',
        },
      )
    } finally {
      setIsLoading(false)
    }
  }

  const handleCallback = ({ images, imageUrls }) => {
    setImages(images)
    setImageUrls(imageUrls)
  }

  const handleCallbackProof = ({ images, imageUrls }) => {
    setProofImages(images)
    setProofImageUrls(imageUrls)
  }

  return (
    <>
      <ModalTakePhotoRelease
        isOpen={isOpenModalTakePhoto}
        toggle={toggleModal}
        callback={handleCallback}
        currentTotalFiles={files.length + imageUrls.length}
        images={images}
        imageUrls={imageUrls}
        setImages={setImages}
        setImageUrls={setImageUrls}
      />

      <ModalTakePhotoRelease
        isOpen={isOpenModalTakePhotoProof}
        toggle={toggleModalProof}
        callback={handleCallbackProof}
        currentTotalFiles={proofFiles.length + proofImageUrls.length}
        images={proofImages}
        imageUrls={proofImageUrls}
        setImages={setProofImages}
        setImageUrls={setProofImageUrls}
      />

      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={() => {
          toggle()
        }}
        autoFocus={false}
        data-testid="detail-transaction-modal-confirm"
      >
        <ModalBody>
          <img src={IconChoosePayment} loading="lazy" alt="icon" />
          {/* Hide pricing selection if COD (useProofOfPayment) is active */}
          {!(
            transaction?.orderDetail?.useProofOfPayment ||
            transaction?.orderDetail?.useProofOfpayment
          ) ? (
            <>
              <h6 className="fw-bold mt-3">Opsi pembayaran ke penjual</h6>
              <p className="text-sm">
                Sebelum konfirmasi barang sampai, silakan pilih opsi pembayaran
                ke penjual terlebih dahulu.
              </p>
              <div className="flex-centered justify-content-between gap-1 mb-3">
                <div
                  className="d-flex flex-column gap-3"
                  style={{
                    maxHeight: '470px',
                    overflowY: 'auto',
                  }}
                >
                  {pricing?.items
                    ?.filter(
                      (e) =>
                        !(
                          isChangeInstantPayment &&
                          e?.fee === 0 &&
                          !e?.originalFee
                        ),
                    )
                    ?.map((e, i) => {
                      return (
                        <div key={i}>
                          <Card
                            style={{
                              backgroundColor:
                                selectedPricing === e?.id
                                  ? '#ECFAFF'
                                  : e?.disable
                                    ? '#F9FAFB'
                                    : '',

                              cursor: !e?.disable && 'pointer',
                            }}
                            className={
                              selectedPricing === e?.id ? 'border-primary' : ''
                            }
                            onClick={() => {
                              if (!e?.disable) {
                                setSelectedPricing(e?.id)
                              }
                            }}
                          >
                            <CardBody className="pb-0">
                              <div className="d-flex flex-row gap-2">
                                <div>
                                  <img
                                    src={
                                      e?.disable ? ICThunderDisable : ICThunder
                                    }
                                    alt="kilat"
                                    width={40}
                                    height={40}
                                  />
                                </div>
                                <div>
                                  {/* HANDLE STRIKEOUT */}
                                  <span style={{ fontWeight: '500' }}>
                                    {e?.fee !== 0 && 'Instan'} {e?.title}{' '}
                                    {e?.originalFee !== undefined &&
                                    e?.originalFee !== null &&
                                    e?.originalFee > e?.fee ? (
                                      <>
                                        <span
                                          style={{
                                            textDecoration: 'line-through',
                                            color: '#667085',
                                          }}
                                        >
                                          Rp
                                          {newFormatThousandSeparator(
                                            Number(e?.originalFee),
                                            0,
                                          )}
                                        </span>
                                        <span
                                          style={{
                                            marginLeft: '5px',
                                            fontWeight: 'bold',
                                            color: 'black',
                                          }}
                                        >
                                          Rp
                                          {newFormatThousandSeparator(
                                            Number(e?.fee),
                                            0,
                                          )}
                                        </span>
                                      </>
                                    ) : (
                                      <span>
                                        Rp
                                        {newFormatThousandSeparator(
                                          Number(e?.fee),
                                          0,
                                        )}
                                      </span>
                                    )}
                                  </span>
                                  {/* END HANDLE STRIKEOUT */}

                                  <p
                                    style={{
                                      color:
                                        selectedPricing === e?.id
                                          ? '#006386'
                                          : '',
                                    }}
                                  >
                                    {e?.disable ? (
                                      <span style={{ color: '#B42318' }}>
                                        {e?.disableReason}
                                      </span>
                                    ) : (
                                      <span>{e.description}</span>
                                    )}
                                  </p>
                                </div>
                                <Input
                                  type="radio"
                                  disabled={e?.disable}
                                  checked={selectedPricing === e?.id}
                                  onChange={() => {
                                    if (!e?.disable) {
                                      setSelectedPricing(e?.id)
                                    }
                                  }}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      )
                    })}
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
          {(transaction?.orderDetail?.useProofOfPayment ||
            transaction?.orderDetail?.useProofOfpayment) &&
            transaction?.orderDetail?.paymentTime && (
              <>
                <CardTitle
                  style={{ fontWeight: 'bold' }}
                  tag="h6"
                  className="mb-1 mt-2"
                >
                  Bukti Pembayaran
                </CardTitle>
                <small>
                  Unggah atau ambil foto bukti pembayaran (maksimal 3).{' '}
                </small>
                <CustomButton
                  size="sm"
                  outline
                  color="primary"
                  className="mb-2"
                  onClick={toggleModalProof}
                  disabled={isProofUploading}
                >
                  Ambil Foto <ArrowRight size={16} />
                </CustomButton>
                <Form
                  encType="multipart/form-data"
                  className="flex-centered border rounded mb-3"
                  style={{ overflow: 'hidden' }}
                >
                  <fieldset className="fieldset">
                    <input
                      className="input-file"
                      id="proofOfPayment"
                      name="proofOfPayment"
                      onChange={async (e) => {
                        const newFiles = e.target.files
                        const totalCurrent =
                          proofFiles.length + proofImages.length

                        if (totalCurrent + newFiles.length > 3) {
                          enqueueSnackbar(
                            'Maksimal total 3 foto (upload + kamera)',
                            {
                              variant: 'error',
                            },
                          )
                          return
                        }
                        setIsProofUploading(true)

                        let newFileNames = []
                        let newUploadedFiles = []

                        try {
                          for (let i = 0; i < newFiles.length; i++) {
                            const uploadedFile = await uploadFile(
                              newFiles[i],
                              () => {},
                              'USER_ID',
                              'PROOFOFPAYMENT',
                              true,
                            )

                            if (uploadedFile.error) {
                              enqueueSnackbar(
                                uploadedFile?.payload || 'Upload gagal',
                                {
                                  variant: 'error',
                                },
                              )
                            } else {
                              const fileId = Date.now() + i
                              newFileNames.push({
                                id: fileId,
                                fileName: newFiles[i].name,
                              })
                              newUploadedFiles.push({
                                id: fileId,
                                fileUrl: uploadedFile?.url,
                              })
                            }
                          }

                          setProofFileNames((prev) => [
                            ...prev,
                            ...newFileNames,
                          ])
                          setProofFiles((prev) => [
                            ...prev,
                            ...newUploadedFiles,
                          ])
                        } catch (err) {
                          enqueueSnackbar('Terjadi kesalahan upload', {
                            variant: 'error',
                          })
                        } finally {
                          setIsProofUploading(false)
                        }
                      }}
                      type="file"
                      accept=".png, .jpeg, .jpg"
                      multiple
                    />
                    <label htmlFor="proofOfPayment" className="d-flex">
                      Unggah
                    </label>
                  </fieldset>
                  <div className="w-100">
                    {isProofUploading ? (
                      <span>
                        <Spinner size="sm" className="me-2" />
                        Sedang mengupload...
                      </span>
                    ) : proofFileNames?.length > 0 ? (
                      proofFileNames?.map((e, i) => (
                        <span className="ms-3 badge-line" key={i}>
                          {e.fileName}
                          <X
                            size={16}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              const filteredFileNames = proofFileNames.filter(
                                (file) => file.id !== e.id,
                              )
                              const filteredFiles = proofFiles.filter(
                                (file) => file.id !== e.id,
                              )
                              setProofFileNames(filteredFileNames)
                              setProofFiles(filteredFiles)
                            }}
                          />
                        </span>
                      ))
                    ) : (
                      <div className="ms-1">Belum ada file</div>
                    )}
                  </div>
                </Form>
                {(proofFiles.length > 0 || proofImages.length > 0) && (
                  <div className="d-flex flex-wrap gap-2 mb-2">
                    {proofFiles.map((f) => (
                      <div key={f.id} className="position-relative">
                        <img
                          src={f.preview || f.fileUrl}
                          alt={f.fileName}
                          className="rounded shadow-lg"
                          style={{
                            width: '100px',
                            height: '100px',
                            objectFit: 'cover',
                          }}
                        />
                        <X
                          size={16}
                          style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            background: 'white',
                            borderRadius: '50%',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setProofFiles((prev) =>
                              prev.filter((file) => file.id !== f.id),
                            )
                            setProofFileNames((prev) =>
                              prev.filter((file) => file.id !== f.id),
                            )
                          }}
                        />
                      </div>
                    ))}

                    {proofImages.map((img, idx) => (
                      <div key={idx} className="position-relative">
                        <img
                          key={idx}
                          src={img}
                          alt={`Captured-proof-${idx}`}
                          className="rounded shadow-lg"
                          style={{
                            width: '100px',
                            height: '100px',
                            objectFit: 'cover',
                          }}
                        />
                        <X
                          size={16}
                          style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            background: 'white',
                            borderRadius: '50%',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setProofImages((prev) =>
                              prev.filter((_, i) => i !== idx),
                            )
                            setProofImageUrls((prev) =>
                              prev.filter((_, i) => i !== idx),
                            )
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          <div>
            {pricing?.items?.some((e) => e?.fee > balance?.uangBelanja) && (
              <div className="mb-4">
                <CustomButton
                  outline
                  block
                  color="primary"
                  onClick={() => navigate('/topup')}
                  disabled={isLoading}
                >
                  Tambah Uang Belanja
                </CustomButton>
              </div>
            )}
          </div>
          <>
            <CardTitle
              style={{ fontWeight: 'bold' }}
              tag="h6"
              className="mb-1 mt-2"
            >
              Bukti Barang Diterima{' '}
              {!serviceProvision?.transactionProof && (
                <span className="fw-normal text-muted">(Opsional)</span>
              )}
            </CardTitle>
            <small>
              Unggah atau ambil foto bukti barang diterima (maksimal 3).{' '}
            </small>
            <CustomButton
              size="sm"
              outline
              color="primary"
              className="mb-2"
              onClick={toggleModal}
              disabled={isUploading}
            >
              Ambil Foto <ArrowRight size={16} />
            </CustomButton>
            <Form
              encType="multipart/form-data"
              className="flex-centered border rounded mb-3"
              style={{ overflow: 'hidden' }}
            >
              <fieldset className="fieldset">
                <input
                  className="input-file"
                  id="confirmTrx"
                  name="confirmTrx"
                  onChange={async (e) => {
                    const newFiles = e.target.files
                    const totalCurrent = files.length + images.length

                    if (totalCurrent + newFiles.length > 3) {
                      enqueueSnackbar(
                        'Maksimal total 3 foto (upload + kamera)',
                        {
                          variant: 'error',
                        },
                      )
                      return
                    }
                    setIsUploading(true)

                    let newFileNames = []
                    let newUploadedFiles = []

                    try {
                      for (let i = 0; i < newFiles.length; i++) {
                        const uploadedFile = await uploadFile(
                          newFiles[i],
                          () => {},
                          'USER_ID',
                          'CONFIRMTRX',
                          true,
                        )

                        if (uploadedFile.error) {
                          enqueueSnackbar(
                            uploadedFile?.payload || 'Upload gagal',
                            {
                              variant: 'error',
                            },
                          )
                        } else {
                          const fileId = Date.now() + i
                          newFileNames.push({
                            id: fileId,
                            fileName: newFiles[i].name,
                          })
                          newUploadedFiles.push({
                            id: fileId,
                            fileUrl: uploadedFile?.url,
                          })
                        }
                      }

                      setFileNames((prev) => [...prev, ...newFileNames])
                      setFiles((prev) => [...prev, ...newUploadedFiles])
                    } catch (err) {
                      enqueueSnackbar('Terjadi kesalahan upload', {
                        variant: 'error',
                      })
                    } finally {
                      setIsUploading(false)
                    }
                  }}
                  type="file"
                  accept=".png, .jpeg, .jpg"
                  multiple
                />
                <label htmlFor="confirmTrx" className="d-flex">
                  Unggah
                </label>
              </fieldset>
              <div className="w-100">
                {isUploading ? (
                  <span>
                    <Spinner size="sm" className="me-2" />
                    Sedang mengunggah...
                  </span>
                ) : fileNames?.length > 0 ? (
                  fileNames?.map((e, i) => (
                    <span className="ms-3 badge-line" key={i}>
                      {e.fileName}
                      <X
                        size={16}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const filteredFileNames = fileNames.filter(
                            (file) => file.id !== e.id,
                          )
                          const filteredFiles = files.filter(
                            (file) => file.id !== e.id,
                          )
                          setFileNames(filteredFileNames)
                          setFiles(filteredFiles)
                        }}
                      />
                    </span>
                  ))
                ) : (
                  <div className="ms-1">Belum ada file</div>
                )}
              </div>
            </Form>
            {(files.length > 0 || images.length > 0) && (
              <div className="d-flex flex-wrap gap-2 mb-2">
                {files.map((f) => (
                  <div key={f.id} className="position-relative">
                    <img
                      src={f.preview || f.fileUrl}
                      alt={f.fileName}
                      className="rounded shadow-lg"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                      }}
                    />
                    <X
                      size={16}
                      style={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        background: 'white',
                        borderRadius: '50%',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setFiles((prev) =>
                          prev.filter((file) => file.id !== f.id),
                        )
                        setFileNames((prev) =>
                          prev.filter((file) => file.id !== f.id),
                        )
                      }}
                    />
                  </div>
                ))}

                {images.map((img, idx) => (
                  <div key={idx} className="position-relative">
                    <img
                      key={idx}
                      src={img}
                      alt={`Captured-${idx}`}
                      className="rounded shadow-lg"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                      }}
                    />
                    <X
                      size={16}
                      style={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        background: 'white',
                        borderRadius: '50%',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setImages((prev) => prev.filter((_, i) => i !== idx))
                        setImageUrls((prev) => prev.filter((_, i) => i !== idx))
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </>

          <div className="mb-4">
            <CardTitle
              style={{ fontWeight: 'bold' }}
              tag="h6"
              className="mb-1 mt-2"
            >
              Catatan (Opsional)
            </CardTitle>
            <Input
              type="textarea"
              rows={3}
              placeholder="Tambahkan catatan jika ada"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>

          <div className="d-flex gap-3">
            <Button
              onClick={() => {
                toggle()
              }}
              className="btn-cancel"
              outline
              block
              data-testid="detail-transaction-modal-confirm-cancel"
            >
              Batal
            </Button>
            <Button
              disabled={
                (serviceProvision?.transactionProof &&
                  files?.length + imageUrls?.length < 1) ||
                ((transaction?.orderDetail?.useProofOfPayment ||
                  transaction?.orderDetail?.useProofOfpayment) &&
                  transaction?.orderDetail?.paymentTime &&
                  proofFiles?.length + proofImageUrls?.length < 1) ||
                (!selectedPricing &&
                  !transaction?.orderDetail?.useProofOfPayment) ||
                isLoading ||
                isUploading ||
                isProofUploading
              }
              color="primary"
              block
              onClick={handleConfirm}
              data-testid="detail-transaction-button-confirm-payment"
            >
              {isLoading && <Spinner size="sm" className="me-2" />} Konfirmasi
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalChoosePayment
